import {ELEMENT} from './elements/base/ElementTypes';

export interface IAppliedRule<T extends number | string = number> {
    predicates: IPredicate<T>[];
    results: IRuleResult[];
    name: string;
    satisfied?: boolean;
}

export interface IPredicate<T extends number | string = number> {
    elementType: ELEMENT;
    elementId: string;
    answers: T[];
    operator: RuleOperator;
}

export interface IRuleResult {
    resultType: RuleResultType;
    slideIds: string[];
}

export enum RuleResultType {
    SHOW_SLIDES = 'SHOW_SLIDES',
    HIDE_SLIDES = 'HIDE_SLIDES',
    BLOCK_SLIDE = 'BLOCK_SLIDE',
    JUMP_TO_SLIDE = 'JUMP_TO_SLIDE',
}

export enum RuleOperator {
    IF = 'IF',
    IF_NOT = 'IF_NOT',
}

export interface IOldAppliedRule {
    result: {label: string; value: string};
    operator: {label: string; value: string};
    predicate: IOldPredicate;
}

export interface IOldPredicate {
    name: string;
    predicateType: string;
    elementId: string;
    elementType: string;
    presentationId: string;
    answer: number | {answerIndex: number};
}
